import createReducer from '../createReducer';
import {
  GET_APPLIANCE_SERIAL_NUMBERS,
  GET_APPLIANCE_SERIAL_NUMBERS_SUCCESS,
  GET_APPLIANCE_SERIAL_NUMBERS_FAIL,
  DELETE_APPLIANCE_SERIAL_NUMBER,
  DELETE_APPLIANCE_SERIAL_NUMBER_SUCCESS,
  DELETE_APPLIANCE_SERIAL_NUMBER_FAIL,
  CREATE_APPLIANCE_SERIAL_NUMBER,
  CREATE_APPLIANCE_SERIAL_NUMBER_FAIL,
  CREATE_APPLIANCE_SERIAL_NUMBER_SUCCESS,
  UPDATE_APPLIANCE_SERIAL_NUMBER,
  UPDATE_APPLIANCE_SERIAL_NUMBER_FAIL,
  UPDATE_APPLIANCE_SERIAL_NUMBER_SUCCESS,
} from '../actions/applianceSerialNumber';

export const initialState = {
  applianceSerialNumbersList: [],
  totalCount: 0,
  loadingList: false,
  saving: false,
};

export default createReducer(initialState, {
  [GET_APPLIANCE_SERIAL_NUMBERS]: draft => {
    draft.loadingList = true;
  },

  [GET_APPLIANCE_SERIAL_NUMBERS_SUCCESS]: (draft, action) => {
    draft.loadingList = false;
    draft.totalCount = action.recordsData.count;
    draft.applianceSerialNumbersList = action.recordsData.data;
  },

  [GET_APPLIANCE_SERIAL_NUMBERS_FAIL]: draft => {
    draft.loadingList = false;
  },

  [DELETE_APPLIANCE_SERIAL_NUMBER]: draft => {
    draft.saving = true;
  },

  [DELETE_APPLIANCE_SERIAL_NUMBER_SUCCESS]: draft => {
    draft.saving = false;
  },

  [DELETE_APPLIANCE_SERIAL_NUMBER_FAIL]: draft => {
    draft.saving = false;
  },

  [CREATE_APPLIANCE_SERIAL_NUMBER]: draft => {
    draft.saving = true;
  },

  [CREATE_APPLIANCE_SERIAL_NUMBER_SUCCESS]: draft => {
    draft.saving = false;
  },

  [CREATE_APPLIANCE_SERIAL_NUMBER_FAIL]: draft => {
    draft.saving = false;
  },

  [UPDATE_APPLIANCE_SERIAL_NUMBER]: draft => {
    draft.saving = true;
  },

  [UPDATE_APPLIANCE_SERIAL_NUMBER_SUCCESS]: draft => {
    draft.saving = false;
  },

  [UPDATE_APPLIANCE_SERIAL_NUMBER_FAIL]: draft => {
    draft.saving = false;
  },
});
